// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
    padding-left: 0%;
    padding-right: 0%;
    box-sizing: border-box;
    width: 100%;
    /*height: 100vh;*/
    /*margin-top: 100px;*/
    display: flex;
    align-items: center;
    justify-content: center;
}

.sub-custom-container {
    display: flex;
    justify-content: center;
    width: 100%;
    /*margin-top: 64px;*/
}

.form-section {
    width: 42%;
    background: white;
    padding: 23px;
    border-radius: 6px;
}

.input-group-sm:nth-child(2) {
    margin-top: 12px;
}

.input-group-sm:nth-child(3) {
    margin-top: 12px;
}
.input-group-sm button{
    width: -moz-fit-content;
    width: fit-content;
}
.input-group-sm{
    justify-content: end;
}
.btnCancel{
    padding: 5px 40px;
}

.privacy-text {
    position: absolute;
    left: 0;
}

.create-group-btn {
    border: none;
    outline: none;
    background: #6c2fbb;
    color: white;
    padding: 4px 25px;
    font-size: 15px;
    border-radius: 4px;
    float: right;
}

label {
    font-size: 15px;
}

h5 {
    font-size: 17px;
}

h4 {
    position: relative;
}

.addAdmin {
    color: #6c2fbb;
    cursor: pointer;
}

.addAdmin:hover {
    text-decoration: underline;
}

.memmber-list {
    color: rgb(0, 0, 0);
    /* margin-right: -31px;
    margin-left: -31px; */
    padding: 7px 0px;
    cursor: pointer;
    height: 300;
    overflow-x: hidden;
}

.video-views {
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.lecture-name {
    margin-bottom: 0;
}

.coll-btn {
    padding: 4px 32px;
    font-size: 14px;
    background: #6c2fbb;
    color: white;
    border-radius: 5px;
    float: right;
    outline: none;
    border: none;
    margin-bottom: 29px;
}

.m-list1 {
    background-color: #cf90f0 !important;
    color: rgb(243, 243, 243);
}

.m-list2 {
    background-color: #cf90f0 !important;
    color: rgb(243, 243, 243);
    padding: 7px 0px;
}

ul {
    list-style: none;
    display: flex;
    padding: 0;
}

ul li {
    margin: 0px 5px;
    /* background: #9e82fc; */
    border-radius: 5px;
    padding: 5px 0px;
    color: rgb(0, 0, 0);
}

.more {
    font-size: 14px;
    color: #6c2fbb;
    cursor: pointer;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .hero {
        padding-left: 0%;
    }
    .form-section {
        width: 100%;
        margin-top: 25px;
        margin-bottom: 45px;
    }
}

::ng-deep .source-image {
    position: relative !important;
    z-index: 22 !important;
}

.user-profile {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.user-profile img {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    min-width: 50px;
    object-fit: cover;
    margin-right: 10px;
}

.profile-image {
    width: 50px;
    min-width: 50px;
    height: 50px;
    font-size: 22px;
    line-height: 30px;
}

.btn-show-password {
    position: absolute;
    right: 0;
    top: 0;
}

.upload-icon{
    background: #5e3ace;
    width: 35px;
    height: 35px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.uploadGroupImg{
    filter: invert(1);
}
.generate-img {
    width: 100%;
    height: 400px;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    padding: 10px;
}

.generate-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
::ng-deep .user-prompt-modal .mat-mdc-dialog-surface {
    padding: 0 !important;
}
.edit-upload-icon {
    width: 25px;
    height: 25px;
}
@media only screen and (max-width: 575px) and (min-width: 320px) {
    .checkbox-input{
        margin-left: 8px !important;
    }
    .custom-switch {
        margin-bottom: 28px;
        display: flex;
        justify-content: space-between;
    }
    .custom-switch .privacy-text {
       width: 85%;
    }
    .custom-switch:nth-child(2) {
        margin-bottom: 10px;
    }
    .custom-switch label {
        font-size: 13px;
    }
}

@media only screen and (max-width: 420px) {
    .memmber-list {
        flex-wrap: nowrap;
    }
    .memmber-list .lecture-name {
        margin-left: 10PX;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/group/create-group/create-group.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAkB;IAAlB,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB;yBACqB;IACrB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,mBAAmB;QACnB,aAAa;QACb,8BAA8B;IAClC;IACA;OACG,UAAU;IACb;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".hero {\n    padding-left: 0%;\n    padding-right: 0%;\n    box-sizing: border-box;\n    width: 100%;\n    /*height: 100vh;*/\n    /*margin-top: 100px;*/\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.sub-custom-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    /*margin-top: 64px;*/\n}\n\n.form-section {\n    width: 42%;\n    background: white;\n    padding: 23px;\n    border-radius: 6px;\n}\n\n.input-group-sm:nth-child(2) {\n    margin-top: 12px;\n}\n\n.input-group-sm:nth-child(3) {\n    margin-top: 12px;\n}\n.input-group-sm button{\n    width: fit-content;\n}\n.input-group-sm{\n    justify-content: end;\n}\n.btnCancel{\n    padding: 5px 40px;\n}\n\n.privacy-text {\n    position: absolute;\n    left: 0;\n}\n\n.create-group-btn {\n    border: none;\n    outline: none;\n    background: #6c2fbb;\n    color: white;\n    padding: 4px 25px;\n    font-size: 15px;\n    border-radius: 4px;\n    float: right;\n}\n\nlabel {\n    font-size: 15px;\n}\n\nh5 {\n    font-size: 17px;\n}\n\nh4 {\n    position: relative;\n}\n\n.addAdmin {\n    color: #6c2fbb;\n    cursor: pointer;\n}\n\n.addAdmin:hover {\n    text-decoration: underline;\n}\n\n.memmber-list {\n    color: rgb(0, 0, 0);\n    /* margin-right: -31px;\n    margin-left: -31px; */\n    padding: 7px 0px;\n    cursor: pointer;\n    height: 300;\n    overflow-x: hidden;\n}\n\n.video-views {\n    height: 300px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.lecture-name {\n    margin-bottom: 0;\n}\n\n.coll-btn {\n    padding: 4px 32px;\n    font-size: 14px;\n    background: #6c2fbb;\n    color: white;\n    border-radius: 5px;\n    float: right;\n    outline: none;\n    border: none;\n    margin-bottom: 29px;\n}\n\n.m-list1 {\n    background-color: #cf90f0 !important;\n    color: rgb(243, 243, 243);\n}\n\n.m-list2 {\n    background-color: #cf90f0 !important;\n    color: rgb(243, 243, 243);\n    padding: 7px 0px;\n}\n\nul {\n    list-style: none;\n    display: flex;\n    padding: 0;\n}\n\nul li {\n    margin: 0px 5px;\n    /* background: #9e82fc; */\n    border-radius: 5px;\n    padding: 5px 0px;\n    color: rgb(0, 0, 0);\n}\n\n.more {\n    font-size: 14px;\n    color: #6c2fbb;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n    .hero {\n        padding-left: 0%;\n    }\n    .form-section {\n        width: 100%;\n        margin-top: 25px;\n        margin-bottom: 45px;\n    }\n}\n\n::ng-deep .source-image {\n    position: relative !important;\n    z-index: 22 !important;\n}\n\n.user-profile {\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.user-profile img {\n    width: 50px;\n    height: 50px;\n    border-radius: 10px;\n    min-width: 50px;\n    object-fit: cover;\n    margin-right: 10px;\n}\n\n.profile-image {\n    width: 50px;\n    min-width: 50px;\n    height: 50px;\n    font-size: 22px;\n    line-height: 30px;\n}\n\n.btn-show-password {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.upload-icon{\n    background: #5e3ace;\n    width: 35px;\n    height: 35px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.uploadGroupImg{\n    filter: invert(1);\n}\n.generate-img {\n    width: 100%;\n    height: 400px;\n    border: 1px solid #e7e7e7;\n    border-radius: 10px;\n    padding: 10px;\n}\n\n.generate-img img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n::ng-deep .user-prompt-modal .mat-mdc-dialog-surface {\n    padding: 0 !important;\n}\n.edit-upload-icon {\n    width: 25px;\n    height: 25px;\n}\n@media only screen and (max-width: 575px) and (min-width: 320px) {\n    .checkbox-input{\n        margin-left: 8px !important;\n    }\n    .custom-switch {\n        margin-bottom: 28px;\n        display: flex;\n        justify-content: space-between;\n    }\n    .custom-switch .privacy-text {\n       width: 85%;\n    }\n    .custom-switch:nth-child(2) {\n        margin-bottom: 10px;\n    }\n    .custom-switch label {\n        font-size: 13px;\n    }\n}\n\n@media only screen and (max-width: 420px) {\n    .memmber-list {\n        flex-wrap: nowrap;\n    }\n    .memmber-list .lecture-name {\n        margin-left: 10PX;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
